import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { MultiTenantApprovalRequest } from '../../types/multiTenantRequest'

const { MULTI_TENANT_REQUESTS_API_URL } = CONSTANT

const acceptMultiTenantRequest = async (
	approval: MultiTenantApprovalRequest
): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(
		`${MULTI_TENANT_REQUESTS_API_URL}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				action: 'APPROVE'
			},
			body: JSON.stringify(approval)
		}
	)
	return response.json()
}

export default acceptMultiTenantRequest
